<template>
  <section id="assist__top">
    <img src="https://cdn.anyteach.cn/img/assist/assist_main.jpg" />
    <h1><i class="anyteachicon anyteach-zhulihuodong" />{{ title }}</h1>
    <p>
      {{ subtitle }}
      <br />{{ desc }}
    </p>
  </section>
</template>

<script>
export default {
  name: "AssistTop",
  props: {
    title: {
      type: String,
      default: "助力赢课时",
    },
    subtitle: {
      type: String,
      default: "最高赢取 30 天欧美外教少儿英语直播课",
    },
    desc: {
      type: String,
      default: "免费升级城市合伙人",
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../style.scss";

#assist__top {
  text-align: center;
  padding-top: 0;
  img {
    width: 90%;
  }
  h1 {
    @include title();
    color: $purple;
    padding: 0 0 5px 0;
    i {
      font-size: inherit;
      margin: 0 5px 0 0;
    }
  }
  p {
    @include body();
  }
}
</style>
